<template>
  <div class="login-page">
    <div class="login-box">
      <div class="login-logo">
        <b>M-Tinker</b> - planis
      </div>
      <div class="login-box-body">
        <form>
          <text-field field-id="username"
                      label="Prihlasovacie meno"
                      placeholder="Zadaj svoje prihlasovacie meno"
                      :maxlength="100"
                      v-model="credentials.username"
                      validation="required|min:5|max:100"></text-field>
          <text-field field-id="password"
                      label="Heslo"
                      placeholder="Zadaj svoje heslo"
                      v-model="credentials.password"
                      :maxlength="20"
                      type="password"
                      validation="required|min:5|max:20"></text-field>
          <div class="row">
            <div class="col-xs-12">
              <div class="pull-right">
                <button class="btn btn-primary btn-block btn-flat" type="submit" @click.prevent="login(credentials)">Prihlásiť</button>
              </div>
            </div>
          </div>
        </form>

      </div>
    </div>
  </div>
</template>

<script>

  import validationMixin from 'components/validationMixin';
  import textField from 'components/form/textField';

  export default {
    components:{textField},
    mixins: [validationMixin],
    data: () => ({
      credentials: {username: '', password: ''}
    }),
    methods: {
      async login(credentials) {
        this.$validator.validateAll().then(() => {
          this.$store.dispatch('auth/logIn', credentials).then((loggedIn) => {
            if (loggedIn) {
              this.$router.push('/overview');
            }
          });
        }).catch(() => {
          //nothing
        });
      }
    }
  }

</script>



// WEBPACK FOOTER //
// client/views/login.vue